import { ApiProperty } from "@nestjs/swagger";

export class RackZoneByIdDto{
    @ApiProperty()
    rackZoneMappingId:number;
}